<template>
  <CCardBody class="pb-4">
    <CInputCheckbox
      :checked.sync="$v.form.isBillingDataRequested.$model"
      custom
      @update:checked="(value) => setBilling(value)"
      label="Insert billing info?"
      addLabelClasses="py-2 font-weight-bold"
      color="primary"
      class="font-weight-semibold font-sm d-flex align-content-center align-items-center"
    />

    <CCol v-if="messages.length" sm="12">
      <transition name="fade">
        <MenssageAlert :messages="messages" />
      </transition>
    </CCol>
    <CForm class="mt-4">
      <div role="group" class="form-group mb-4">
        <label>{{ $t('general.input.placeholder.country') }} *</label>
        <v-select
          class="selectCountry"
          :disabled="!form.isBillingDataRequested"
          :clearable="false"
          :class="{ 'is-invalid': $v.form.countryId.$error }"
          v-model="$v.form.countryId.$model"
          :isValid="checkIfValid('countryId')"
          @option:selected="setCountry"
          :options="optionsCountriesNames"
          id="country"
        >
          <template #selected-option="{ label, flag }">
            <div class="d-flex align-items-center">
              <img :src="flag" alt="" width="25" />
              <span class="ml-2 text-capitalize">{{ label }}</span>
            </div>
          </template>

          <template v-slot:option="option">
            <span class="py-4">
              <img :src="option.flag" width="30" height="auto" />
              <span class="ml-2">
                {{ option.label }}
              </span>
            </span>
          </template>
        </v-select>
        <div class="invalid-feedback" v-if="$v.form.countryId.$error">
          {{ $t('settings.organization.formOrganization.form.invalid-feedback.field-is-required') }}
        </div>
      </div>

      <transition-group name="fade">
        <section v-if="form.isBillingDataRequested && hasCountry" key="a">
          <div role="group" class="form-group mb-4">
            <label for="">{{ $t('settings.organization.formOrganization.form.input-label.taxNumber') }} <span v-if="extraCommunity">*</span></label>
            <CInput
              class="newInput mb-4"
              :value.sync="$v.form.taxIdentificationNumber.$model"
              :isValid="checkIfValid('taxIdentificationNumber')"
              :invalidFeedback="$t('settings.organization.formOrganization.form.invalid-feedback.field-is-required')"
            />
          </div>
          <CInput
            class="newInput mb-4"
            :label="`${$t('settings.organization.formOrganization.form.input-label.social-designation')} *`"
            :value.sync="$v.form.companyName.$model"
            :isValid="checkIfValid('companyName')"
            :invalidFeedback="`{${$t('settings.organization.formOrganization.form.invalid-feedback.field-is-required')}*`"
            id="companyName"
          />
          <CInput
            class="newInput mb-4"
            :label="`${$t('settings.organization.formOrganization.form.input-label.Address')} *`"
            :value.sync="$v.form.streetAddress.$model"
            :isValid="checkIfValid('streetAddress')"
            :invalidFeedback="`${$t('settings.organization.formOrganization.form.invalid-feedback.field-is-required')} *`"
          />
          <CRow>
            <CCol xs="12" sm="6">
              <CInput
                class="newInput mb-4"
                :label="`${$t('settings.organization.formOrganization.form.input-label.zipCode')} *`"
                :value.sync="$v.form.postalCode.$model"
                :isValid="checkIfValid('postalCode')"
                :invalidFeedback="$t('settings.organization.formOrganization.form.invalid-feedback.field-is-required')"
              />
            </CCol>
            <CCol xs="12" sm="6">
              <CInput
                class="newInput mb-4"
                :label="`${$t('settings.organization.formOrganization.form.input-label.city')} *`"
                :value.sync="$v.form.city.$model"
                :isValid="checkIfValid('city')"
                :invalidFeedback="$t('settings.organization.formOrganization.form.invalid-feedback.field-is-required')"
              />
            </CCol>
          </CRow>
        </section>
      </transition-group>
      <div class="d-flex justify-content-end mt-3">
        <CButton class="font-base btn btn-outline-light text-gray-600 px-5 py-3" @click="prev(1)">
          {{ $t('manageplan.component.card.payment-method.button.back') }}
        </CButton>
        <CButton color="primary" class="font-base ml-3 px-5 py-3" @click="nextStep(3)" :disabled="!formInValid || loading">
          <span class="px-5">{{ $t('manageplan.component.card.payment-method.button.next') }}</span>
        </CButton>
      </div>
    </CForm>
  </CCardBody>
</template>

<script>
import services from '@/services.js'
import MenssageAlert from '@/components/MenssageAlert'
import { requiredUnless, helpers, requiredIf } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import { nameCountries } from '@/utils/countriesUtils.js'
import vSelect from 'vue-select'
import { getItem } from '@/utils/StorageManager'

import countries from '@/countriesList'

const zipcd = helpers.regex('zipcd', /^([-A-Za-z0-9+/.+/]){1,20}$/)

export default {
  name: 'FormBilling',
  components: {
    vSelect,
    MenssageAlert,
  },
  mixins: [validationMixin],
  data() {
    return {
      hasBillingInfo: false,
      optionsCountriesNames: [],
      organizationId: null,
      messages: [],
      loading: false,
      form: {
        isBillingDataRequested: false,
        companyName: '',
        taxIdentificationNumber: '',
        streetAddress: '',
        postalCode: '',
        city: '',
        countryId: null,
      },
    }
  },
  validations: {
    form: {
      isBillingDataRequested: {
        required: false,
      },
      companyName: {
        required: requiredUnless('billingInfo'),
      },
      taxIdentificationNumber: {
        required:
          requiredUnless('billingInfo') &&
          requiredUnless(function (formModel) {
            if (formModel.countryId && formModel.countryId.vies) {
              return formModel.countryId.vies || formModel.countryId.value == 'PT'
            }
          }),
        // numeric,
      },
      streetAddress: {
        required: requiredUnless('billingInfo'),
      },
      postalCode: {
        required: requiredUnless('billingInfo'),
        // zipcd,
        // numeric,
      },
      countryId: {
        required: requiredUnless('billingInfo'),
      },
      city: {
        required: requiredUnless('billingInfo'),
      },
    },
  },

  mounted() {
    this.$store.dispatch('backOffice/steps/updateInfoPropStep', { prop: 'selectPayment', data: {} })
    this.optionsCountriesNames = nameCountries(this)
    this.optionsCountriesNames.push(
      {
        flag: '/img/flags/pt.svg',
        label: this.$t(`general.components.selects.countries.Portugal_Acores`),
        value: 'PT',
        detailCountry: 'acores',
        vies: false,
      },
      {
        flag: '/img/flags/pt.svg',
        label: this.$t(`general.components.selects.countries.Portugal_Madeira`),
        value: 'PT',
        detailCountry: 'madeira',
        vies: false,
      },
    )

    this.optionsCountriesNames = this.optionsCountriesNames.sort((countryA, countryB) => {
      if (countryA.label < countryB.label) {
        return -1
      }
      if (countryA.label > countryB.label) {
        return 1
      }
      return 0
    })

    this.organizationId = this.$route.params.organizationId
    this.getBillingInfo()
  },

  computed: {
    isValid() {
      return !this.$v.form.$invalid
    },

    formInValid() {
      if (!this.form.isBillingDataRequested) {
        return true
      }

      return this.isValid
    },

    hasCountry() {
      return this.form.countryId
    },

    extraCommunity() {
      return this.form.countryId.vies || this.form.countryId.value == 'PT'
    },

    billingInfo() {
      return this.form.isBillingDataRequested
    },
  },

  methods: {
    checkIfValid(fieldName) {
      const field = this.$v.form[fieldName]
      if (!field.$dirty) {
        return null
      }
      return !(field.$invalid || null)
    },

    prev() {
      this.$store.dispatch('backOffice/steps/setCurrentStep', 1)
    },

    nextStep() {
      this.loading = true
      if (this.form.isBillingDataRequested) {
        this.$v.$touch()

        if (!this.isValid) return

        this.$store
          .dispatch('backOffice/steps/validateBillingInfo', {
            organizationId: this.organizationId,
            prop: 'billingInfo',
            info: this.handleFormPayload(this.form),
          })
          .then(() => {
            this.$store.dispatch('backOffice/steps/setCurrentStep', 3)
            this.$store.dispatch('backOffice/steps/updateInfoPropStep', { prop: 'maxStep', data: 3 })
          })
          .catch((error) => {
            console.log('catch', error, error.response)
            this.messages.push({
              status: 'danger',
              text: error.response.data.data.message || 'erro',
            })
          })
          .finally(() => {
            this.loading = false
          })

        return
      }

      this.$store
        .dispatch('backOffice/steps/validateBillingInfo', {
          prop: 'billingInfo',
          info: { isBillingDataRequested: false },
          organizationId: this.organizationId,
        })
        .then(() => {
          this.$store.dispatch('backOffice/steps/setCurrentStep', 3)
          this.$store.dispatch('backOffice/steps/updateInfoPropStep', { prop: 'maxStep', data: 3 })
        })
        .catch((error) => {
          console.log('catch', error, error.response)
          this.messages.push({
            status: 'danger',
            text: error.response.data.data.message || 'erro',
          })
        })
        .finally(() => {
          this.loading = false
        })
    },

    handleFormPayload(form) {
      let newForm = { ...form }
      newForm.countryId = form.countryId.value
      newForm.detailCountry = form.countryId.detailCountry

      return newForm
    },

    getBillingInfo() {
      this.loading = true

      if (this.getBillingInfoState()) {
        return
      }

      if (!this.organizationId) this.loading = false

      services
        .getBillingInfo(this.organizationId)
        .then((res) => {
          if (res.data.data.billingInfo.name) {
            this.form.isBillingDataRequested = true
            this.hasBillingInfo = true
          }

          this.form.companyName = res.data.data.billingInfo.name
          this.form.taxIdentificationNumber = res.data.data.billingInfo.taxIdentificationNumber
          this.form.streetAddress = res.data.data.billingInfo.address
          this.form.postalCode = res.data.data.billingInfo.postalCode
          this.form.city = res.data.data.billingInfo.city
          this.form.countryId = this.getObjectCountry(res.data.data.billingInfo.country)
        })
        .finally(() => {
          this.loading = false
        })
    },

    getBillingInfoState() {
      const data = JSON.parse(getItem('stateStep')).billingInfo

      if (data) {
        if (data.isBillingDataRequested) {
          this.form.isBillingDataRequested = true
          this.hasBillingInfo = true
          this.form.companyName = data.companyName
          this.form.taxIdentificationNumber = data.taxIdentificationNumber
          this.form.streetAddress = data.streetAddress
          this.form.postalCode = data.postalCode
          this.form.city = data.city
          this.form.countryId = this.getObjectCountry(data.countryId, data.detailCountry)
        }

        this.loading = false

        return true
      }

      return false
    },

    setCountry(value) {
      this.form.countryId = value
      this.$v.$reset()
    },

    setBilling(value) {
      if (!value) {
        this.form = {
          isBillingDataRequested: false,
          companyName: '',
          taxIdentificationNumber: '',
          streetAddress: '',
          postalCode: '',
          city: '',
          countryId: null,
        }
        this.$v.$reset()

        return
      }

      if (this.hasBillingInfo) {
        this.getBillingInfo()
        this.$v.$reset()
        return
      }
    },

    getObjectCountry(countrySelected, detailCountry) {
      const country = countries.filter((country) => {
        if (country.name.toLowerCase() == countrySelected.toLowerCase() || country.code.toLowerCase() == countrySelected.toLowerCase()) {
          return country
        }
      })[0]

      let label = this.$t(`general.components.selects.countries.${country.name}`) || ''
      const isDetailCountryDiffFromName = detailCountry?.toLowerCase() !== country.name.toLowerCase()
      if (detailCountry?.length > 2 && isDetailCountryDiffFromName) {
        label += ` - ${detailCountry}`
      }

      return {
        flag: country.flag || '',
        label: label,
        value: country.code || '',
        vies: country.vies || '',
      }
    },
  },
}
</script>

<style lang="scss">
.selectCountry {
  border: 1px solid #dee2e6;
  border-radius: 5px;
  .v-select .vs__dropdown-toggle {
    border-radius: 0;
    border: none;
    height: 50px;
    padding: 0 15px;
  }
}
</style>
